/*
*
* =================================================================================================================

    AKTIVACIA ORGANIZACUE - po registrácii

* =================================================================================================================
*
*/

import React, { useEffect, useState, useRef } from 'react';

import './App.css';
import './styles.css';
import './globals_conditions';
import { ButtonNew, DialogDates, EmptyList, FormError, FormLabel, FormSelect, FormSpace, FormText, FormYesNo, Icon, Line, Loading, ShowError, ShowOK, SuperAdmin, TextInput } from './items';
import { styles } from './styles';
import { Backdrop, Button, FormControlLabel, IconButton, MenuItem, Paper, Radio, RadioGroup, Select, rgbToHex, useMediaQuery } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFrown, faInfoCircle, faLayerGroup, faPerson, faPlusCircle, faUser, faXmark } from '@fortawesome/free-solid-svg-icons';
import { CheckPermission, Debug, GetLanguage, GetPages, IsEmpty, SaveLogin, paswordCheck } from './functions';
import { Today } from './functions_date';
import { sk } from './language_sk';
import { useNavigate, useParams } from 'react-router-dom';


export const OrganizationActivate = (props) => {

    const navigate = useNavigate();
    const logo = require('./react/app/logo_vision.png');

    let radius = global.radius;
    let color = global.themes[0];

    // SYSTEM
    const [isBusy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const [language, setLanguage] = useState(0);

    const [showOK, setShowOK] = useState(false);
    const [showError, setShowError] = useState(false);

    // PARAMS
    const [user, setUser] = useState(false);
    const [linkError, setLinkError] = useState(false);
    const [password, setPassword] = useState('');

    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);

    let { func } = props;
    let params = useParams();
    var running = false;
    var lang = GetLanguage(language);

    const inputRef = useRef(null);

    useEffect(() => {
        if (running == false) {
            db_get();
            running = true;
        }

        return () => {
        };

    }, []);

    const db_get = async () => {
        setBusy(true);
        try {
            const response = await fetch(
                global.db_url + 'organization_uid', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    uid: params.uid
                })
            })

            const json = await response.json();
            Debug(json);
            if (json.ok > 0) {
                if (json.organization == false) {
                    // NENAJDENA ORGANIZACIA -> CHYBA
                    setLinkError(true);
                } else {
                    setUser(json.organization);
                    setLanguage(json.organization.language_id);

                    // FOCUS TO TEXTAREA
                    setTimeout(() => {
                        inputRef.current.focus();
                    }, 300);
                }
            }
            setBusy(false);

        } catch (error) {
            console.log(error);
            setBusy(false);
        }
    }


    const ShowErrorPress = (value) => {
        setShowError(false);
    }

    const ShowOKPress = () => {
        setShowOK(false);
        navigate('/application');
    }

    const GoToCRM = () => {
       navigate('/');
    }

    return (
        <div style={{ ...styles.Block, height: height, fontFamily: 'roboto', msOverflowStyle: 'none', scrollbarWidth: 'none', backgroundColor: color.desktop_background, backgroundSize: 'cover' }} className='container'>
            <Paper elevation={3} style={{ ...styles.Block, maxWidth: 420, width: '100%', borderRadius: global.radius, paddingTop: 40, paddingBottom: 40 }}>
                {user != false ?
                    <div style={{ ...styles.Block }}>
                        <img src={logo} style={{ width: '100%', height: '100%', maxWidth: 150, maxHeight: 150, objectFit: 'contain' }}></img>
                        <p style={{ ...styles.TextLarge, marginTop: 20 }}>{lang.organization_verified}</p>
                        <div style={{ ...styles.Block, marginTop: 80 }}>
                            <Button onClick={() => GoToCRM()} style={{ ...styles.ButtonThemed, width: 200, backgroundColor: color.button_dark }}>{lang.organization_to_crm}</Button>
                        </div>
                    </div>
                    : null}

                {linkError == true ?
                    <div style={{ ...styles.Block }}>
                        <FontAwesomeIcon style={{ height: 32, color: color.dark_red }} icon={faFrown} />
                        <p style={{ ...styles.TextSmall, marginTop: 20 }}>{lang.link_error}</p>
                    </div>
                    : null}
            </Paper>

            {showOK == true ?
                <ShowOK center theme={0} func={ShowOKPress.bind(this)} />
                : null}

            {showError == true ?
                <ShowError center theme={0} text={lang.db_error} sub_text={lang.db_error_text} func={ShowErrorPress.bind(this)} />
                : null}

            {isBusy == true ?
                <Loading center></Loading>
                : null}

        </div>
    );
}
